import { useEffect, useRef, useState } from 'react';
import { useResizeObserver } from 'usehooks-ts';

import { useMutationObserver } from './useMutationObserver';

type IsTruncatedReturnType = React.RefObject<HTMLDivElement | null>;

export default function useIsTruncated(): [IsTruncatedReturnType, boolean] {
  const ref = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const { width } = useResizeObserver({
    ref: ref as React.RefObject<HTMLDivElement>,
    box: 'border-box',
  });

  useMutationObserver(ref as React.RefObject<HTMLDivElement>, () => {
    const el = ref.current;
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  });

  useEffect(() => {
    const el = ref.current;
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  }, [width]);

  return [ref, isTruncated];
}
